<template>
  <div data-test="whitelist-hint" class="text-gray-dark text-sm mt-1 flex items-center gap-1 h-8">
    ⚠️ URL behind a firewall? Whitelist IP address:
    <span class="font-bold">{{ VPC_IP_ADDRESS }}</span>
    <CopyButton :text="VPC_IP_ADDRESS" copied-label="IP copied!" icon-size="14"/>
  </div>
</template>

<script>
import CopyButton from '@/components/common/CopyButton.vue'

const VPC_IP_ADDRESS = '18.159.180.64'

export default {
  name: 'WhitelistHint',
  components: { CopyButton },
  data() {
    return {
      VPC_IP_ADDRESS
    }
  }
}
</script>
